var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"container-full-bg-gray",attrs:{"fluid":""}},[_c('object',{staticClass:"pdf",attrs:{"data":"declaracion_responsable_antifraude.pdf","width":"800","height":"500"}})])}
var staticRenderFns = []

export { render, staticRenderFns }